import { Component, OnInit } from '@angular/core';
import { AttendanceService } from '../../../../../services/attendance-service/attendance.service';
import { AttendanceDatas, AttendanceTotalData, Days, Employee } from '../../../../../models/attendance.model';
import { LazyLoadEvent } from 'primeng/api';
import { TableLazyLoadEvent } from 'primeng/table';
import { ExcelService } from '../../../../../services/export/excel.service';
import { Router } from '@angular/router';
import { formatDate } from '@angular/common';
import { CommonService } from '../../../../../services/common/common.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EmployeeListService } from '../../../../../services/employee/employee-list.service';

@Component({
    selector: 'app-attendance',
    templateUrl: './attendance.component.html',
    styleUrl: './attendance.component.scss'
})
export class AttendanceComponent implements OnInit {

    attendanceData: AttendanceDatas[] = [];
    attendanceTotalData: AttendanceTotalData[] = [];
    employees: Employee[] = [];

    // currentdate!: string;
    currentdate: any;
    days: Days[] = [];
    totalRecords: number = 0;
    currentPage: number = 0;
    loading: boolean = false;
    currentSortOrder: 'asc' | 'desc' = 'asc';
    currentSortField: any = '_id';
    page = 0; // Current active page
    pageSize = 10; //number of items per page
    numberofitems = 10 //number of items per page
    searchEmployees: string = '';
    filterCriteria: string = '';
    angularDateFormat: any;
    currency: any;
    date: any = 'dd-mm-yy'


    // statuscount

    todayOnTimeCount!: number | undefined;
    todayLateCheckInCount!: number | undefined;
    todayEarlyCheckInCount!: number | undefined;
    totalTodayCount!: number | undefined;
    totalTodayAbsentCount!: number | undefined;

    yesterdayOnTimeCount!: number | undefined;
    yesterdayLateCheckInCount!: number | undefined;
    yesterdayEarlyCheckInCount!: number | undefined;
    totalYesterdayCount!: number | undefined;
    totalYesterdayAbsentCount!: number | undefined;
    searchForm: FormGroup;
    month: any;
    year: any;
    employee_id: any;
    role:any;

    buttonName: string = 'Calendar View';

    constructor(private attendanceService: AttendanceService, private readonly employeeService: EmployeeListService,
        private excelService: ExcelService, private readonly route: Router, private readonly commonService: CommonService, private readonly fb: FormBuilder) {
        this.searchForm = this.fb.group({
            attendancedate: [[]],
            employee_id: [''],
            month: [''],
            year: ['']
        });
    }
    ngOnInit(): void {
        this.loading = true;
        const data: any = this.commonService.getLocalStorageData();
        this.role = data.role
        if(this.role == 4){
            this.searchForm.get('employee_id')?.setValue(data.userID)
            this.employee_id = data.userID
            this.onFilterChange()
        }
        if (data?.companyID) {
            this.commonService.getCompanySettingFormat(data.companyID).subscribe({
                next: (resp) => {
                    this.currency = resp.data.default_currency;
                    this.date = resp.data.date_format;
                    this.angularDateFormat = this.commonService.convertPrimeNGToAngularFormat(this.date);
                    // this.getAttendance();
                    this.getEmployeeList(data?.locationID);
                },
                error: (err) => {
                    console.error('Failed to fetch company settings', err);
                    this.loading = false;
                }
            });
        }
    }

    buttonNameOnClick() {
        if (this.buttonName === 'Calendar View') {
            this.route.navigate(['app/attendance']);
        }
    }

    onDateChange(selectedDate: any): void {
        if (!selectedDate) return;
        this.currentdate = selectedDate;
        this.currentPage = 0;
        this.getAttendance();
        this.getStatusCount();
    }

    onSearchChange(event: any) {
        const searchTerm = event.trim();
        if (searchTerm !== '') {
            this.searchInput(searchTerm);
        } else {
            this.searchEmployees = '';
            this.currentPage = 0;
            this.getAttendance();
        }
    }

    searchInput(value: string) {
        if (!value) return;
        this.searchEmployees = value;
        this.currentPage = 0;
        this.getAttendance();
    }

    onFilterSelected(event: Event): void {
        const target = event.target as HTMLSelectElement;
        this.filterCriteria = target.value;
        this.currentPage = 0;
        this.getAttendance();
    }

    clearfilter() {
        this.filterCriteria = '';
        this.searchEmployees = '';
        this.currentPage = 0;
        this.getAttendance();
        this.getStatusCount();
    }

    getStatusCount() {
        this.attendanceService.getStatusCount(this.currentdate).subscribe({
            next: resp => {
                this.days = resp.data;

                const todayData = this.days[0].today;
                this.todayOnTimeCount = todayData.find(item => item.status === "On Time")?.count;
                this.todayEarlyCheckInCount = todayData.find(item => item.status === "Early Check-In")?.count;
                this.todayLateCheckInCount = todayData.find(item => item.status === "Late Check-In")?.count;
                this.totalTodayAbsentCount = todayData.find(item => item.status === "Absent")?.count;
                this.totalTodayCount = resp.data[0].totalTodayCount;

                const yesterdayData = this.days[0].yesterday;
                this.yesterdayOnTimeCount = yesterdayData.find(item => item.status === "On Time")?.count;
                this.yesterdayEarlyCheckInCount = yesterdayData.find(item => item.status === "Early Check-In")?.count;
                this.yesterdayLateCheckInCount = yesterdayData.find(item => item.status === "Late Check-In")?.count;
                this.totalYesterdayAbsentCount = yesterdayData.find(item => item.status === "Absent")?.count;
                this.totalYesterdayCount = resp.data[0].totalYesterdayCount;
            },
            error: err => {
                console.log(err);
            }
        });
    }

    changeDate(days: number) {
        const currentDate = new Date(this.currentdate);
        currentDate.setDate(currentDate.getDate() + days);
        this.currentdate = currentDate.toISOString().split('T')[0];
        this.currentPage = 0;
        this.getAttendance();
        this.getStatusCount();
    }

    handlePageChange(newPage: number): void {
        this.currentPage = newPage && newPage > 0 ? newPage - 1 : 0;
        this.getAttendance();
    }

    employeeList: any = []
    getEmployeeList(id: any): Promise<void> {
        return new Promise((resolve, reject) => {
            this.employeeService.getEmpListWithoutPagination({ location_id: id })
                .subscribe({
                    next: (resp) => {

                        this.employeeList = resp.data.map((employee: any) => ({
                            ...employee,
                            displayName: `${employee.firstname} ${employee.lastname} (${employee.employeecode})`
                        }));
                        resolve();
                    },
                    error: (err) => {
                        this.employeeList = []
                        reject(err);
                    }
                });
        });
    }

    getAttendance() {
        const formattedDate = this.currentdate
            ? formatDate(this.currentdate, 'yyyy-MM-dd', 'en-US')
            : [];

        const employeeId = this.searchForm.get('employee_id')?.value;

        const params = {
            page: this.currentPage,
            month: this.month,
            year: this.year,
            size: this.pageSize,
            order: this.currentSortOrder,
            orderby: this.currentSortField,
            search: this.searchEmployees,
            attendancedate: formattedDate,
            status: this.filterCriteria,
            employee_id: employeeId || ''
        };

        this.params = params;
        this.loading = true;

        this.attendanceService.getEmployees(this.params).subscribe({
            next: (data) => {
                this.attendanceData = data.data.datas;

                this.employees = this.attendanceData.map(item => {
                    const { employee, ...attendanceData } = item;
                    return { ...attendanceData, ...employee };
                });

                this.totalRecords = data.data.totalItems;
                this.currentPage = data.data.currentPage + 1;
                this.loading = false;
            },
            error: () => {
                this.loading = false;
            }
        });
    }

    onFilterChange(): void {
        const month = this.searchForm.get('month')?.value;
        const year = this.searchForm.get('year')?.value;
        const employeeId = this.searchForm.get('employee_id')?.value;

        if (month && year) {
            this.month = month;
            this.year = year;
            this.employee_id = employeeId;
            this.searchForm.get('attendancedate')?.setValue([]);
            this.currentPage = 0;
            this.getAttendance();
        }
    }


    exportTable() {
        this.excelService.exportTableToExcel('menusTable');
    }

    toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
    }

    // Declare your default values
    isMenuOpen = false;
    params: any;


    months = [
        { value: '01', label: 'January' },
        { value: '02', label: 'February' },
        { value: '03', label: 'March' },
        { value: '04', label: 'April' },
        { value: '05', label: 'May' },
        { value: '06', label: 'June' },
        { value: '07', label: 'July' },
        { value: '08', label: 'August' },
        { value: '09', label: 'September' },
        { value: '10', label: 'October' },
        { value: '11', label: 'November' },
        { value: '12', label: 'December' },
    ];

    years = Array.from({ length: 4 }, (_, i) => {
        const year = new Date().getFullYear() - i;
        return { value: year, label: year.toString() };
    });

}
